import { Route, Switch } from "react-router-dom";
import HistoricoMensagemPage from "./Historico/HistoricoMensagem";
import MensagemListagemPage from "./Listagem";

function MensagensPages() {
  return (
    <Switch>
      <Route
        exact
        path="/administracao/mensagens"
        component={MensagemListagemPage}
      />
      <Route
        exact
        path="/administracao/mensagens/:id"
        component={HistoricoMensagemPage}
      />
    </Switch>
  );
}

export default MensagensPages;
